module.exports = __webpack_public_path__ + "static/media/hulladek.cde81637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/hulladek.jpg
// module id = 76
// module chunks = 0